import React from "react";
import { IInvoiceMaterialPosition } from "../../interfaces/IInvoiceMaterialPosition";
import { IUnit } from "../../interfaces/IUnit";
import { IMaterial } from "../../interfaces/IMaterial";
import { IMaterialCategory } from "../../interfaces/IMaterialCategory";
import { IMaterialSubcategory } from "../../interfaces/IMaterialSubcategory";
import { OfferMaterialPositionRow } from "../offer/Childs/OfferMaterialPositionRow";
import { IOfferMaterialPosition } from "../../interfaces/IOfferMaterialPosition";

interface IProps {
    invMaterial: IInvoiceMaterialPosition;
    invMaterials: IInvoiceMaterialPosition[];
    setInvMaterials: Function;

    units: IUnit[];
    materials: IMaterial[];
    materialCategories: IMaterialCategory[];
    materialSubcategories: IMaterialSubcategory[];
}


export const InvoicePosMaterialRow:React.FC<IProps> = ({
    invMaterial,
    invMaterials,
    setInvMaterials,

    units,
    materials,
    materialCategories,
    materialSubcategories
}) => {
    const currentMaterialPosition = {
        ...invMaterial,
        Offer: invMaterial.Invoice,
        position: 1,
        Partner: null
    } as IOfferMaterialPosition;

    const offerMaterialPositionArray = invMaterials.map(invMate => {
        return {
            ...invMate,
            Offer: invMaterial.Invoice,
            position: 1,
            Partner: null
        } as IOfferMaterialPosition
    })

    const setOfferMaterialPositionArray = (offerMaterialPositions:IOfferMaterialPosition[]) => {
        let newInvMaterials = offerMaterialPositions.map(offerMat => {
            return {
                ...offerMat,
                Invoice: offerMat.Offer
            } as IInvoiceMaterialPosition
        })
        setInvMaterials([
            ...newInvMaterials
        ])
    }



    return(
        <OfferMaterialPositionRow
            key={`materialpos-${invMaterial.id}`}
            currentMaterialPosition={currentMaterialPosition}
            offerMaterialPositionArray={offerMaterialPositionArray}
            setOfferMaterialPositionArray={setOfferMaterialPositionArray}
            unitArray={units}
            materialArray={materials}
            materialCategoryArray={materialCategories}
            materialSubcategoryArray={materialSubcategories}
        />
    )
}